import React from "react";
import ChatbotIcon from "../../../../../assets/chatbot-icon";

const Index = (props) => {
  // const {handleSubmit} =props;
  const {chatbotData} =props;
  const {totalChar} =props;

  return (
    <></>
    // <div className="p-5 rounded-large bg-white shadow-box border border-grey max-w-[386px] w-full">
    //   <h5 className="text-lg font-medium text-[#2B2B2B] leading-5 mb-9">
    //     Sources
    //   </h5>
    //   <h6 className="mb-2 text-sm font-medium leading-none text-black">
    //     Total detected characters
    //   </h6>
    //   <p className="text-sm text-[#747474] leading-none font-light">
    //     <strong className="font-medium text-black">{totalChar}</strong>/{chatbotData?.total_char_sum} limit
    //   </p>
    //   {/* <button
    //     onClick={handleSubmit}
    //     type="button"
    //     className="px-9 mt-5 text-sm font-normal text-white h-10 flex items-center justify-center gap-2 !bg-[#115B9D] rounded-extra_large shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed">
    //     <ChatbotIcon classes="text-[#115B9D]   group-hover:text-white text-lg " />
    //     Retrain Chatbot
    //   </button> */}
    // </div>
  );
};

export default Index;
